import { render, staticRenderFns } from "./ArtistDashboard.vue?vue&type=template&id=95b6404c&scoped=true&"
import script from "./ArtistDashboard.vue?vue&type=script&lang=js&"
export * from "./ArtistDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ArtistDashboard.vue?vue&type=style&index=0&id=95b6404c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b6404c",
  null
  
)

export default component.exports